import React, {useState, useEffect} from 'react'
import NavigationBar from './NavBar'
import axios from 'axios'
// import Calendar from 'react-calendar'
// import 'react-calendar/dist/Calendar.css'
import Calendar from '../calendar/Calendar'


const EditDocuments = (props) => {
    var CryptoJS = require("crypto-js");
    const [ valueForSubmit, setValueForSubmit ] = useState('')
    const [ dateSelected, setDateSelected ] = useState(new Date())
    const [ calendarGate, setCalendarGate] = useState(false)
    const [ nameFromListArray, setNameFromListArray] = useState([])
    const [ nameFromList, setNameFromList] = useState('')
    const [ displayNameArray, setDisplayNameArray ] = useState('names_list_array_container_none')
    const [ countryFromListArray, setCountryFromListArray] = useState([])
    const [ countryFromList, setCountryFromList] = useState()
    const [ displayCountryArray, setDisplayCountryArray] = useState('names_list_array_container_none')
    const [ submitPressed, setSubmitPressed] = useState('Submit')
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ arrayOfImages, setArrayOfImages ] = useState([])
    const [ dateOption, setDateOption ] = useState(true)
    const [ countryOption, setCountryOption ] = useState(true)
    const [ optionsSelections, setOptionsSelections ] = useState(null)
    const [ editPage, setEditPage ] = useState(null)

    useEffect( () => {
        if (props.image) {
            setNameFromList(props.image.name)
            setValueForSubmit(props.image.imagesLink)
            setDateSelected(new Date(props.image.expiryDate))
            setCountryFromList(props.image.countryOfIssue ? props.image.countryOfIssue : 'None')
            if (new Date(props.image.expiryDate).toDateString() === 'Thu Jan 03 2030') {
                setDateOption(false)
            }
        }
    }, [props])
    var theCalendar
    
    // date selection function
    var theCalendar
    const handleDateSelection = (date) => {
        setDateSelected(date)
        setCalendarGate(false)
    }
    // make the calendar
    if (calendarGate) {
        theCalendar = (
            theCalendar = (
                <div>
                    <Calendar
                        startingDay='Sun'
                        returnDate={handleDateSelection}
                    />
                </div>
            )
        )
    }

    // make react happy
    const handleChangeCalendar = () => {

    }

    // calendar function
    const handleMakingCalendar = () => {
        setCalendarGate(true)
    }

    // save image to cloudinary
    var uploadImage = (e) => {
        const files = e.target.files
        const data = new FormData()
        data.append('file', files[0])
        data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET)
        data.append("api_key", process.env.REACT_APP_CLOUDINARY_API_KEY)
        axios.post(process.env.REACT_APP_UPLOAD_IMAGE, data).then(response => {
            let myOtherResponse = ''
            if (response.data.secure_url.includes('.pdf')) {
                let myNewName = response.data.secure_url.replace(/.pdf/, '.png')
                response.data.secure_url = myNewName
            }
            setValueForSubmit(myOtherResponse ? myOtherResponse : response.data.secure_url)
        })
    }

     // handle country selection
     let countryList = 
     ['Afghanistan',
     'Albania',
     'Algeria',
     'Aland Islands',
     'American Samoa',
     'Anguilla',
     'Andorra',
     'Angola',
     'Antilles - Netherlands',
     'Antigua and Barbuda',
     'Antarctica',
     'Argentina',
     'Armenia',
     'Australia',
     'Austria',
     'Aruba',
     'Azerbaijan',
     'Bosnia and Herzegovina',
     'Barbados',
     'Bangladesh',
     'Belgium',
     'Burkina Faso',
     'Bulgaria',
     'Bahrain',
     'Burundi',
     'Benin',
     'Bermuda',
     'Brunei Darussalam',
     'Bolivia',
     'Brazil',
     'Bahamas',
     'Bhutan',
     'Bouvet Island',
     'Botswana',
     'Belarus',
     'Belize',
     'Cambodia',
     'Cameroon',
     'Canada',
     'Cape Verde',
     'Central African Republic',
     'Chad',
     'Chile',
     'China',
     'Christmas Island',
     'Cocos (Keeling) Islands',
     'Colombia',
     'Congo',
     "Cote D'Ivoire (Ivory Coast)",
     'Cook Islands',
     'Costa Rica',
     'Croatia (Hrvatska)',
     'Cuba',
     'Cyprus',
     'Czech Republic',
     'Democratic Republic of the Congo',
     'Djibouti',
     'Denmark',
     'Dominica',
     'Dominican Republic',
     'Ecuador',
     'Egypt',
     'El Salvador',
     'East Timor',
     'Estonia',
     'Equatorial Guinea',
     'Eritrea',
     'Ethiopia',
     'Finland',
     'Fiji',
     'Falkland Islands (Malvinas)',
     'Federated States of Micronesia',
     'Faroe Islands',
     'France',
     'France, Metropolitan',
     'French Guiana',
     'French Polynesia',
     'Gabon',
     'Gambia',
     'Germany',
     'Ghana',
     'Gibraltar',
     'Great Britain (UK)',
     'Grenada',
     'Georgia',
     'Greece',
     'Greenland',
     'Guinea',
     'Guadeloupe',
     'S. Georgia and S. Sandwich Islands',
     'Guatemala',
     'Guam',
     'Guinea-Bissau',
     'Guyana',
     'Hong Kong',
     'Heard Island and McDonald Islands',
     'Honduras',
     'Haiti',
     'Hungary',
     'Indonesia',
     'Ireland',
     'Israel',
     'India',
     'British Indian Ocean Territory',
     'Iraq',
     'Iran',
     'Italy',
     'Jamaica',
     'Jordan',
     'Japan',
     'Kenya',
     'Kyrgyzstan',
     'Kiribati',
     'Comoros',
     'Saint Kitts and Nevis',
     'Korea (North)',
     'Korea (South)',
     'Kuwait',
     'Cayman Islands',
     'Kazakhstan',
     'Laos',
     'Lebanon',
     'Saint Lucia',
     'Liechtenstein',
     'Sri Lanka',
     'Liberia',
     'Lesotho',
     'Lithuania',
     'Luxembourg',
     'Latvia',
     'Libya',
     'Macedonia',
     'Macao',
     'Madagascar',
     'Malaysia',
     'Mali',
     'Malawi',
     'Mauritania',
     'Marshall Islands',
     'Martinique',
     'Mauritius',
     'Mayotte',
     'Malta',
     'Mexico',
     'Morocco',
     'Monaco',
     'Moldova',
     'Mongolia',
     'Myanmar',
     'Northern Mariana Islands',
     'Montserrat',
     'Maldives',
     'Mozambique',
     'Namibia',
     'New Caledonia',
     'Niger',
     'Norfolk Island',
     'Nigeria',
     'Nicaragua',
     'Netherlands',
     'Norway',
     'Nepal',
     'Nauru',
     'Niue',
     'New Zealand (Aotearoa)',
     'Oman',
     'Panama',
     'Peru',
     'Papua New Guinea',
     'Philippines',
     'Pakistan',
     'Poland',
     'Saint Pierre and Miquelon',
     'Serbia and Montenegro',
     'Pitcairn',
     'Puerto Rico',
     'Palestinian Territory',
     'Portugal',
     'Palau',
     'Paraguay',
     'Qatar',
     'Reunion',
     'Romania',
     'Russian Federation',
     'Rwanda',
     'Saudi Arabia',
     'Samoa',
     'Saint Helena',
     'Saint Vincent and the Grenadines',
     'San Marino',
     'Sao Tome and Principe',
     'Senegal',
     'Seychelles',
     'Sierra Leone',
     'Singapore',
     'Slovakia',
     'Slovenia',
     'Solomon Islands',
     'Somalia',
     'South Africa',
     'Spain',
     'Sudan',
     'Suriname',
     'Svalbard and Jan Mayen',
     'Sweden',
     'Switzerland',
     'Syria',
     'USSR (former)',
     'Swaziland',
     'Taiwan',
     'Tanzania',
     'Tajikistan',
     'Thailand',
     'Timor-Leste',
     'Togo',
     'Tokelau',
     'Tonga',
     'Trinidad and Tobago',
     'Tunisia',
     'Turkey',
     'Turkmenistan',
     'Turks and Caicos Islands',
     'Tuvalu',
     'Ukraine',
     'Uganda',
     'United Arab Emirates',
     'United Kingdom',
     'United States',
     'United States Minor Outlying Islands',
     'Uruguay',
     'Uzbekistan',
     'Vanuatu',
     'Vatican City State',
     'Venezuela',
     'Virgin Islands (British)',
     'Virgin Islands (U.S.)',
     'Viet Nam',
     'Wallis and Futuna',
     'Western Sahara',
     'Yemen',
     'Yugoslavia (former)',
     'Zambia',
     'Zaire (former)',
     'Zimbabwe']

    // handle selecting a country
    const handleCountryClick = (e, country) => {
        setCountryFromList(country)
        setCountryFromListArray([])
        setDisplayCountryArray('names_list_array_container_none')
    }   

    // handle selecting name of document
    const handleNameClick = (e, targetName) => {
        setNameFromList(targetName)
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // function for making drop down for names list
    const mouseEnterName = () => {
        let localArray = []
        namesListArray.forEach( (ele, id) => {
            localArray.push(
                <div key={id} className='names_in_names_list_array_forms_two' onClick={(e, targetName) => handleNameClick(e, ele)}>
                    <p>{ele}</p>
                </div>    
            )
        })
        setNameFromListArray(localArray)
        setDisplayNameArray('names_list_array_container')
    }

    // function for mouse leaving names list
    const mouseLeaveName = () => {
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // list of names for documents
    let namesListArray = [
        'Passport',
        'ID',
        'Visa',
        'Photo',
        'Driving licence Front',
        'Driving licence Back',
        'DVLA Check',
        'BGC',
        'D&A test',
        'Application Package',
        'NIN',
        'UTR',
        'POA'
    ]

    // dealing with country selection
    const handleChange = (e) => {
        let localArray = []
        if (e.target.value) {
            countryList.forEach( (ele, id) => {
                if (ele.toLowerCase().includes(e.target.value.toLowerCase())) {
                    localArray.push(
                        <div key={id} className='names_in_names_list_array_forms_edit' onClick={(e, targetName) => handleCountryClick(e, ele)}>
                            <p>{ele}</p>
                        </div> 
                    )
                }
            })
        }
        setCountryFromListArray(localArray)
        setDisplayCountryArray('names_list_array_container')
    }

    // handle click turn things blank
    const handleClick = () => {
        setCountryFromList(null)
        setCountryFromListArray([])
        setDisplayCountryArray('names_list_array_container_none')
    }

     // get rid off error screen
     const handleDeleteError = () => {
        setErrorMessage(null)
    }

    // date toggle
    const handleDateToggle = () => {
        dateOption ? setDateOption(false) : setDateOption(true)
    }
    
    // handle country toggle
    const handleCountryToggle = () => {
        countryOption ? setCountryOption(false) : setCountryOption(true)
    }

    // handling the selection for the options
    useEffect( () => {
        setOptionsSelections(
            <div className='documentsForVerificationTop'>
                <div className='compliance_add_driver_button_submit' onClick={handleDateToggle}>
                    <span className='span_in_complaince_button'>Date Selection</span>
                </div>
                <div className='compliance_add_driver_button_submit' onClick={handleCountryToggle}>
                    <span className='span_in_complaince_button'>Country Selection</span>
                </div>
            </div>
        )

    }, [countryOption, dateOption])

    // return to the documents for verification page
    const returnButton = (response) => {
        props.returnFunc(response)
    }

    // handle submitting document to backend
    var handleSubmit = (e) => {
        e.preventDefault()
        if (valueForSubmit.length > 0) {
            if (props.superUser) {
                async function putData(url = '', data = {}) {
                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const response = await fetch(url, {
                        method: 'PUT', 
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${originalText}`
                        },
                        body: JSON.stringify(data)
                        });
        
                    return response ? response.json() : console.log('no reponse')
                };

                // handle not entering date
                const dateSelector = () => {
                    if (dateOption) {
                        return dateSelected.toDateString()
                    } else {
                        return 'Thu Jan 3 2030'
                    }
                }

                putData(`https://backendpajamas.herokuapp.com/images/${props.image.image_id}/`, {
                    imagesLink: valueForSubmit,
                    name: nameFromList,
                    countryOfIssue: countryFromList ? countryFromList : 'n/a',
                    expiryDate: dateSelector(),
                }).then( response => {
                    returnButton(response)
                })
            } else {
                if (props.station.includes(props.selectedDriver.location)) {
                    // handle not entering date
                    const dateSelector = () => {
                        if (dateOption) {
                            return dateSelected.toDateString()
                        } else {
                            return 'Thu Jan 3 2030'
                        }
                    }
                    async function putData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'Put', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                            });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    
                    putData(`https://backendpajamas.herokuapp.com/images/${props.image.image_id}/`, {
                        imagesLink: valueForSubmit,
                        name: nameFromList,
                        countryOfIssue: countryFromList ? countryFromList : 'n/a',
                        expiryDate: dateSelector(),
                    }).then( response => {
                        returnButton(response)
                    })
                } else {
                    setErrorMessage(
                        <div className='errorMessageAllPages'>
                            <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                            <button className='errorButton' onClick={handleDeleteError}>Return</button>
                        </div>
                    )
                }
            }    
        } else {
            setErrorMessage(
                <div className='errorMessageAllPages'>
                    <h3 id='errorMessage'>Please select a document to upload. </h3>
                    <button className='errorButton' onClick={handleDeleteError}>Return</button>
                </div>
            )
        }
    }

    // attempt to fix this
    const handleInvalidDates = (theDate) => {
        try {
            let localDate = new Date(theDate).toLocaleDateString('en-GB')
            return localDate
        } catch (error) {
            console.log(error)
            if (error) {
                let localDate = new Date().toLocaleDateString('en-GB')
                return localDate
            }
        }
    }

    var submitFilesDiv
    if (props.image && dateOption && countryOption) {
        submitFilesDiv = (
            <div className='submit_files_two_freedom'>
                {optionsSelections}
                <form onSubmit={handleSubmit} className='form_on_document_page'>
                    <div className='enter_information_documents'>
                        <h3 className='documents_h3'>Upload Image for {props.image.name}</h3>
                            <div className='input_information_documents_tab'>
                            <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                            <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Name of Document:</h3>
                                        <input type="text" 
                                        name="theName"  
                                        value={nameFromList} 
                                        autoComplete='off' 
                                        className='document_input_forms' 
                                        onMouseEnter={mouseEnterName}
                                        />
                                        <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                            {nameFromListArray}
                                        </div>
                                </div>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Expiry Date:</h3>
                                        <input type="text" name="expiryDate"  className='document_input_forms' value={handleInvalidDates(dateSelected)}  onChange={handleChangeCalendar} autoComplete='off' onClick={handleMakingCalendar}/>
                                        {theCalendar}
                                </div>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Country of Issue:</h3>
                                        <input type="text" name="country" value={countryFromList} className='document_input_forms' autoComplete='off' onChange={handleChange} onClick={handleClick}/>
                                        <div className={displayCountryArray} >
                                            {countryFromListArray}
                                        </div>
                                </div>
                            </div>
                            <br />
                            <div className="formsButtonContainer">
                                <div className="button-container-2">
                                    <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                                </div> 
                            </div>
                    </div>
                    <div className='makeThisGoToBottom'>
                        <button className='compliance_add_driver_button_submit' onClick={returnButton}>
                            <span className='span_in_complaince_button'>Return</span> 
                        </button>
                    </div>
                </form>
            </div>
        )
    } else if (props.image && countryOption && !dateOption) {
        submitFilesDiv = (
            <div className='submit_files_two_freedom'>
                {optionsSelections}
                <form onSubmit={handleSubmit} className='form_on_document_page'>
                    <div className='enter_information_documents'>
                        <h3 className='documents_h3'>Upload Image for {props.image.name}</h3>
                            <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                            <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                            <div className='input_information_documents_tab'>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Name of Document:</h3>
                                        <input type="text" 
                                        name="theName"  
                                        value={nameFromList} 
                                        autoComplete='off' 
                                        className='document_input_forms' 
                                        onMouseEnter={mouseEnterName}
                                        />
                                        <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                            {nameFromListArray}
                                        </div>
                                </div>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Country of Issue:</h3>
                                        <input type="text" name="country" value={countryFromList} className='document_input_forms' autoComplete='off' onChange={handleChange} onClick={handleClick}/>
                                        <div className={displayCountryArray} >
                                            {countryFromListArray}
                                        </div>
                                </div>
                            </div>
                            <br />
                        <div className="button-container-2" id="formsButtonSubmit">
                            <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                        </div> 
                    </div>
                    <div className='makeThisGoToBottom'>
                        <button className='compliance_add_driver_button_submit' onClick={returnButton}>
                            <span className='span_in_complaince_button'>Return</span> 
                        </button>
                    </div>
                </form>
            </div>
        )
    } else if (props.image && dateOption && !countryOption) {
        submitFilesDiv = (
            <div className='submit_files_two_freedom'>
                {optionsSelections}
                <form onSubmit={handleSubmit} className='form_on_document_page'>
                    <div className='enter_information_documents'>
                        <h3 className='documents_h3'>Upload Image for {props.image.name}</h3>
                            <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                            <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                            <div className='input_information_documents_tab'>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Name of Document:</h3>
                                        <input type="text" 
                                        name="theName"  
                                        value={nameFromList} 
                                        autoComplete='off' 
                                        className='document_input_forms' 
                                        onMouseEnter={mouseEnterName}
                                        />
                                        <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                            {nameFromListArray}
                                        </div>
                                </div>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Expiry Date:</h3>
                                        <input type="text" name="expiryDate"  className='document_input_forms'value={dateSelected.toLocaleDateString('en-GB')}  onChange={handleChangeCalendar} autoComplete='off' onClick={handleMakingCalendar}/>
                                        {theCalendar}
                                </div>
                            </div>
                            <br />
                        <div className="button-container-2" id="formsButtonSubmit">
                            <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                        </div> 
                    </div>
                    <div className='makeThisGoToBottom'>
                        <button className='compliance_add_driver_button_submit' onClick={returnButton}>
                            <span className='span_in_complaince_button'>Return</span> 
                        </button>
                    </div>
                </form>
            </div>
        )
    } else if (props.image && !countryOption && !dateOption) {
        submitFilesDiv = (
            <div className='submit_files_two_freedom'>
                {optionsSelections}
                <form onSubmit={handleSubmit} className='form_on_document_page'>
                    <div className='enter_information_documents'>
                        <h3 className='documents_h3'>Upload Image for {props.image.name}</h3>
                            <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                            <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                            <div className='input_information_documents_tab'>
                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Name of Document:</h3>
                                        <input type="text" 
                                        name="theName"  
                                        value={nameFromList} 
                                        autoComplete='off' 
                                        className='document_input_forms' 
                                        onMouseEnter={mouseEnterName}
                                        />
                                        <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                            {nameFromListArray}
                                        </div>
                                </div>
                            </div>
                            <br />
                        <div className="button-container-2" id="formsButtonSubmit">
                            <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                        </div> 
                    </div>
                    <div className='makeThisGoToBottom'>
                        <button className='compliance_add_driver_button_submit' onClick={returnButton}>
                            <span className='span_in_complaince_button'>Return</span> 
                        </button>
                    </div>
                </form>
            </div>
        )
    }

    return(
        <>
            {errorMessage}
            {/* <div className='home_content'> */}
                <div className='content_edit_page'>
                <h1 className='editDocumentsH1'>Edit {props.image ? props.image.name : 'Document'}</h1>
                    {submitFilesDiv}
                </div>
            {/* </div> */}
        </>
    )
}

export default EditDocuments